import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../entity/User";
import { CACHE_KEYS } from "../../services/local/CacheManager";



interface AuthState {
    token: string | null;
    user: User | null;
}

const initialState: AuthState = {
    token: localStorage.getItem(CACHE_KEYS.TOKEN),
    user: JSON.parse(localStorage.getItem(CACHE_KEYS.USER_PROFILE) || "null"),
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginSuccess: (state, action: PayloadAction<{ token: string; user: User }>) => {
            state.token = action.payload.token;
            state.user = action.payload.user;
            localStorage.setItem(CACHE_KEYS.TOKEN, action.payload.token);
            localStorage.setItem(CACHE_KEYS.USER_PROFILE, JSON.stringify(action.payload.user));
        },
        logout: (state) => {
            state.token = null;
            state.user = null;
            localStorage.removeItem(CACHE_KEYS.TOKEN);
            localStorage.removeItem(CACHE_KEYS.USER_PROFILE);
        },
    },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
